var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuantityPicker',{staticClass:"QuantityInput",attrs:{"max-qty":_vm.maxQty,"counter":_vm.counter,"min-qty":_vm.minQty,"qty":_vm._quantity,"isLoading":_vm.isLoading,"isAvailable":_vm.isAvailable},on:{"onUpdate":_vm.onUpdate}})}
var staticRenderFns = []

export { render, staticRenderFns }